import TextField from 'material-ui/TextField';
import moment from 'moment';
import React, { Component } from 'react';
import autoBind from 'react-autobind';

class TextDatePicker extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.minDate !== prevProps.minDate || this.props.maxDate !== prevProps.maxDate) {
            this.initOrUpdate(this.props);
        }
    }

    componentDidMount() {
        const field = this.props;
        this.initOrUpdate(field);
    }

    initOrUpdate(field) {
        const minDateFormatted = field.minDate ? moment(field.minDate, 'DD.MM.YYYY').format('DD.MM.YYYY') : false;
        const maxDateFormatted = field.maxDate ? moment(field.maxDate, 'DD.MM.YYYY').format('DD.MM.YYYY') : false;
        $(this.textField.input).datetimepicker({
            ...field.input,
            onChangeDateTime: value => {
                if (field.input.onChange)
                    field.input.onChange(value ? moment(value, 'DD.MM.YYYY').format('DD.MM.YYYY') : null);
            },
            format: 'DD.MM.YYYY',
            value: field.input.value ? moment(field.input.value, 'DD.MM.YYYY').format('DD.MM.YYYY') : null,
            formatDate: 'DD.MM.YYYY',
            minDate: minDateFormatted,
            maxDate: maxDateFormatted,
            step: 30,
            mask: '39.19.2999',
            scrollInput: false,
            timepicker: false,
            dayOfWeekStart: 1, // start with Monday
        });
    }

    componentWillUnmount() {
        $(this.textField.input).datetimepicker('destroy');
    }

    render() {
        const field = this.props;

        return (
            <TextField
                {...field.input}
                id={field.name}
                type="text"
                ref={ref => (this.textField = ref)}
                floatingLabelText={this.props.label}
                floatingLabelFixed={true}
                errorText={field.meta.error}
            />
        );
    }
}

export default TextDatePicker;
